let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("evcuy")).then(() => parcelRequire('gi5Fg'));